import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNITS } from '../artikelstamm.api';
import { ProductQuery } from '../types/product.query';
import { Unit } from '../types/unit';

@Injectable()
export class UnitRepository extends ReadonlyHttpApiListRepository<Unit[], ProductQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNITS);
  }

  override getLoadPathParams(params: ProductQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
